const genericErrorMessage = 'An error occurred. Please try again later.';

export { genericErrorMessage };
